import { createContext, useContext } from "react"
import type { BlocksContentType, BlocksContextType } from "../types"
import { type ReducerActionType } from "./useSyncedReducer"

export type SyncerContextType = {
  customizationBusy?: boolean
  customizationError?: string | null
  setCustomizationsEnabled?: (enabled: boolean) => Promise<void>
  checkCustomizationResponses?: () => Promise<boolean>
  content: BlocksContentType | null
  blocksContext: BlocksContextType | null
  blockTypes: BlocksContextType["blockTypes"] | null
  contentLoading: boolean
  syncer:
    | ((
        action: ReducerActionType,
        state: Record<string, any>,
        dispatch: (action: ReducerActionType) => void
      ) => void)
    | null
  needsContentReset?: boolean
  loadPreviewContent?: () => Promise<BlocksContentType>
}

const defaultSyncState: SyncerContextType = {
  syncer: null,
  content: null,
  blocksContext: null,
  blockTypes: null,
  contentLoading: false,
  needsContentReset: false
}

const SyncerContext = createContext<SyncerContextType>(defaultSyncState)
export const useSyncer = () => useContext(SyncerContext)

export default SyncerContext
